// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"4af3ea42","152":"37aa135f","205":"551b977d","246":"ad956d86","287":"86f0038c","520":"26ed196f","535":"681292c3","884":"2b377253","936":"de738950"}[chunkId] + ".chunk.js";
};